// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-reservation-pin-paid {
    border: 1px solid rgb(36, 192, 128);
    background-color: honeydew;
    padding: 15px;
}

.payment-reservation-pin h4 {
    color: black;
}

.payment-reservation-pin-not-paid {
    border: 1px solid #24c07f;
    padding: 15px;
    background-color: rgba(199, 58, 61, 0.08);
}

.payment-reservation-pin div {
    border-color: #24c07f;
}

.payment-reservation-pin button {
    width: 100%;
}

.payment-reservation-pin .error_message {
    margin-top: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/payment.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".payment-reservation-pin-paid {\n    border: 1px solid rgb(36, 192, 128);\n    background-color: honeydew;\n    padding: 15px;\n}\n\n.payment-reservation-pin h4 {\n    color: black;\n}\n\n.payment-reservation-pin-not-paid {\n    border: 1px solid #24c07f;\n    padding: 15px;\n    background-color: rgba(199, 58, 61, 0.08);\n}\n\n.payment-reservation-pin div {\n    border-color: #24c07f;\n}\n\n.payment-reservation-pin button {\n    width: 100%;\n}\n\n.payment-reservation-pin .error_message {\n    margin-top: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
